<template>
  <div class="reports-add-jobs">
    <el-button
      style="width: 100%; padding-left: 8px; padding-right: 8px" class="add" @click="openDialog"
    >
      Заполнить
    </el-button>

    <el-dialog append-to-body title="Применить к выбраным работникам:" :visible.sync="dialogObject">
      <div style="display: flex">
        <el-input placeholder="Часы" v-model="form.hours" style="margin-right: 5px"></el-input>
        <el-input placeholder="Код" v-model="form.code" style="margin-left: 5px"></el-input>
      </div>

      <el-form-item label="Комментарий">
        <el-input type="textarea" v-model="form.comment"></el-input>
      </el-form-item>

      <el-checkbox v-model="selectAll" @change="isCopy = false">Добавить всех работников</el-checkbox>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="close">Отменить
        </el-button>
        <el-button
          @click="remove"
          style="margin-left: 4px; padding: 12px 8px"
          type="danger">Удалить
        </el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="save"
          type="primary">Сохранить
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import firebase from 'firebase';
import {getChildList} from '@/utils/getChild';
import _ from 'lodash';
import {filterObjects} from "../../../../utils/filterJobs";
import {getPermission} from "../../../../firestore/permission";
import FilterSelect from "../../../../components/FilterSelect";
import TabelProxy from "../../../../proxy/TabelProxy";

export default {
  name: 'MultipleUser',
  components: {FilterSelect},
  props: ['isWorkType', 'company', 'role', 'companyData', 'workDirs', 'companies', 'users', 'allUsers', 'workTypes', 'filterUsersProps', 'currentUser'],
  data() {
    return {
      dialogObject: false,
      selectAll: false,
      currentCompany: 'ALL',
      isCopy: false,
      form: {
        workTypeId: 'NOT_SELECT',
        code: "",
        hours: '',
        dirId: null,
        comment: ""
      }
    };
  },
  computed: {
    isMultipleCompany() {
      return this.companyData && (this.role === 'admin' || this.companyData.enableSelectAll)
    },
    filterUsers() {
      return (this.allUsers || []).filter(({companyId}) => companyId === this.company)
    },
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  watch: {
    currentUser() {
      try {
        const currentCompany = this.currentUser.company || 'ALL'
        const result = (this.companies.find(({label}) => label === currentCompany))
        if (result) {
          this.currentCompany = result.value
        }
      } catch (e) {
      }
    }
  },
  methods: {
    remove() {
      this.$emit('update', this.users.filter((user) => {
        return !user.isSelect || !this.filterUsersProps.find((fU) => JSON.stringify(user) === JSON.stringify(fU))
      }));
      this.close();
    },
    copy() {
      const result = []
      this.users.forEach((user) => {
        result.push(user)
        if (user.isSelect && this.filterUsersProps.find((fU) => JSON.stringify(user) === JSON.stringify(fU))) {

          const _user = {...user, isSelect: false}

          if (this.form.workTypeId  !== 'NOT_SELECT' && this.form.workTypeId  !== 'WITHOUT'  && this.form.workTypeId) {
            _user.workTypeId = this.form.workTypeId
          }


          if (this.form.code) {
            _user.code = this.form.code
          }

          if (this.form.dirId) {
            _user.dirId = this.form.dirId
          }

          if (this.form.hours) {
            _user.hours = this.form.hours
          }

          if (this.form.comment) {
            _user.comment = this.form.comment
          }

          result.push(_user)
        }
      })

      setTimeout(() => {
        this.$emit('update', result.map((res) => {
          if(res.workTypeId === 'WITHOUT' || !res.workTypeId) {
            res.workTypeId = ""
          }

          return res
        }));
        this.close();
      }, 500);
    },
    openDialog() {
      this.dialogObject = true;
    },
    save() {
      if (this.isCopy) {
        return this.copy()
      }
      let users = [...this.users]
      let filterUsers = [...this.filterUsers];
      if (this.selectAll) {
        if (this.isMultipleCompany) {
          if (this.currentCompany === 'ALL') {
            filterUsers = [...this.allUsers]
          } else {
            filterUsers = [...this.allUsers].filter(({companyId}) => companyId === this.currentCompany)
          }
        }

        users = [...users, ...(filterUsers.filter((user) => {
          return !this.users.find(({employeeId}) => employeeId === user.value)
        }).map((user) => {
          return {
            ...this.form,
            employeeId: user.value,
            isSelect: false,
            profId: user.profId,
            // workTypeId: (this.form.workTypeId === 'NOT_SELECT' ||  this.form.workTypeId === 'WITHOUT' ||  !this.form.workTypeId) ? '' : this.form.workTypeId,
          }
        }) || [])]
      }

      const result = users.map((user) => {
        if (!user.isSelect || !this.filterUsersProps.find((fU) => JSON.stringify(user) === JSON.stringify(fU))) {
          return user
        }
        if (this.form.workTypeId !== 'NOT_SELECT') {
          user.workTypeId = this.form.workTypeId && this.form.workTypeId !== 'WITHOUT' ? this.form.workTypeId : ""
        }

        if (this.form.code) {
          user.code = this.form.code
        }

        if (this.form.dirId) {
          user.dirId = this.form.dirId
        }


        if (this.form.hours) {
          user.hours = this.form.hours
        }

        if (this.form.comment) {
          user.comment = this.form.comment
        }

        return {
          ...user,
        }
      })


      this.$emit('update', result.map((res) => {
        if(res.workTypeId === 'WITHOUT' || !res.workTypeId || res.workTypeId === 'NOT_SELECT') {
          res.workTypeId = ""
        }

        return res
      }))
      this.close();
    },
    close() {
      this.dialogObject = false;

      this.form = {
        employeeId: null,
        dirId: null,
        workTypeId: 'NOT_SELECT',
        profId: "",
        code: "",
        hours: '',
        comment: ""
      }
    },
  },
};
</script>

<style lang="scss">
.add-jobs {
  display: flex;
  flex-direction: column;

  .jobs-ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 8px;
  }

  .jobs-li {
    padding: 4px 10px !important;
    width: calc(100% - 20px);
    justify-content: flex-start;
    text-align: left;
    height: auto !important;
    min-height: 48px !important;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    span {
      text-align: left;
    }

    &.link {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      a {
        color: #3676CB;
        text-decoration: none;
      }

      &:hover {
        background: rgba(0, 0, 0, 0);
      }
    }

    &:hover {
      background: #eee;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .select-value {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    .input-with-select {
      margin-top: 12px;
    }

    > > > {
      .el-select .el-input {
        width: 142px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOne/components/MultipleUser.vue